import React from "react";
import { CgSoftwareDownload } from 'react-icons/cg';
import ImgixFilePreview from "../../newComponents/ImgixFilePreview";
import YoutubeEmbed from "../../newComponents/youtubeEmbed";

const videoAndBrochures = ({ block }) => {

  return (
    <section>
          <div className="shell">
            <div className="grid grid-cols-1 md:grid-cols-2 grid-rows-2 md:grid-rows-1 gap-2 mb-4">
              {block.whatWeDoFeatureVideo.url ? <div><YoutubeEmbed title={block.whatWeDoFeatureVideo.title} url={block.whatWeDoFeatureVideo.url}/></div> : ''}
              {block.whatWeDoBrochureLink ? 
                <figure>
                  <iframe title="Brochure" style={{"border":"1px solid #777"}} src={block.whatWeDoBrochureLink} width="100%" height="100%" frameBorder={0} allowFullScreen />
                </figure>
                :
                block.whatWeDoFeatureBrochure[0] && 
                  <div className={block.whatWeDoFeatureBrochure[0] ? "relative border-gray-300 border-solid border mx-auto" : null} style={block.whatWeDoBrochureAspectRatio === "portrait" ? { "aspect-ratio": "1/1.4142", "height": "316px" } : null}>
                      <a href={block.whatWeDoFeatureBrochure[0].url} target="_blank" rel="noreferrer">
                        <ImgixFilePreview fileUrl={block.whatWeDoFeatureBrochure[0].url}  className={block.whatWeDoBrochureAspectRatio === "portrait" ? "aspect-[5/7]" : "aspect-[16/9]"} />
                        <span className="absolute  top-0 left-0 w-full h-full flex justify-center items-center">
                          <CgSoftwareDownload className="w-12 h-12 text-white" style={{filter: "drop-shadow( 3px 3px 5px rgba(0, 0, 0, .9))"}} alt=""/>
                        </span>
                      </a>
                      {block.whatWeDoBrochureCaption ? <p className="box__title h6 m-0 p-4">{ block.whatWeDoBrochureCaption }</p> : <></> }
                  </div>
              }
              {block.whatWeDoBrochureLink2 ? 
                <figure>
                  <iframe title="Brochure" style={{"border":"1px solid #777"}} src={block.whatWeDoBrochureLink2} width="100%" height="100%" frameBorder={0} allowFullScreen />
                </figure>
                :
                block.whatWeDoFeatureBrochure2[0] && 
                  <div className={block.whatWeDoFeatureBrochure2[0] ? "relative border-gray-300 border-solid border mx-auto" : null} style={block.whatWeDoBrochureAspectRatio2 === "portrait" ? { "aspect-ratio": "1/1.4142", "height": "316px" } : null}>
                      <a href={block.whatWeDoFeatureBrochure2[0].url} target="_blank" rel="noreferrer">
                        <ImgixFilePreview fileUrl={block.whatWeDoFeatureBrochure2[0].url} className={block.whatWeDoBrochureAspectRatio2 === "portrait" ? "aspect-[5/7]" : "aspect-[16/9]"} />
                        <span className="absolute  top-0 left-0 w-full h-full flex justify-center items-center">
                          <CgSoftwareDownload className="w-12 h-12 text-white" style={{filter: "drop-shadow( 3px 3px 5px rgba(0, 0, 0, .9))"}} alt=""/>
                        </span>
                      </a>
                      {block.whatWeDoBrochureCapton2 ? <p className="box__title h6 m-0 p-4">{ block.whatWeDoBrochureCapton2 }</p> : <></> }
                  </div>
              }
            </div>
          </div>
        </section>
  );
}

export default videoAndBrochures; 
